module.exports = __webpack_public_path__ + "static/media/400053_01.898267f8.png";